import React from "react";
import SubmissionsList from "./components/SubmissionsList";
import { LANES } from "./submissionHelpers";

/**
 * The submissions queue. One screen, three type filters — mounted at
 * /submissions, /submissions/applications and /submissions/credit-auths so the
 * nav dropdown deep-links into one (mirrors the lendmarq-los /applications/:slug
 * routes).
 *
 * Grouping by borrower is a TOGGLE rather than a fourth filter, because it
 * composes with all three: you can group within Loan apps just as sensibly as
 * within All. /submissions/by-borrower stays mounted so the nav entry and any
 * bookmarks keep working — it opens All with the toggle already on.
 */
export const AllSubmissionsScreen = () => <SubmissionsList lane={LANES.ALL} />;

export const SubmissionsByBorrowerScreen = () => (
  <SubmissionsList lane={LANES.ALL} initialGrouped />
);

export const LoanApplicationsScreen = () => (
  <SubmissionsList lane={LANES.LOAN_APPLICATION} />
);

export const CreditAuthorizationsScreen = () => (
  <SubmissionsList lane={LANES.CREDIT_AUTHORIZATION} />
);

export default AllSubmissionsScreen;
